import React from "react";
import {
  FaDatabase,
  FaExchangeAlt,
  FaFolderOpen,
  FaFileDownload,
  FaUpload,
  FaLanguage,
  FaCheckCircle,
  FaLayerGroup,
  FaRocket,
  FaUserShield,
  FaTools,
  FaHistory,
  FaMapMarkerAlt
} from "react-icons/fa";

export const SidebarData = [
  {
    title: "Collections",
    icon: <FaDatabase />,
    children: [
      {
        title: "Collections",
        path: "/",
        icon: <FaFolderOpen />
      }
    ]
  },

  {
    title: "Transfer",
    icon: <FaExchangeAlt />,
    children: [
      {
        title: "Raw Contents",
        path: "/contents",
        icon: <FaDatabase />
      },
      {
        title: "Locate & Merge",
        path: "/locate-merge",
        icon: <FaLayerGroup />
      },
      {
        title: "Transfer to Source",
        path: "/datatransfer",
        icon: <FaExchangeAlt />
      },
      {
        title: "Download for Translation",
        path: "/downloaddata",
        icon: <FaFileDownload />
      }
    ]
  },

  {
    title: "Translation",
    icon: <FaLanguage />,
    children: [
      {
        title: "Upload Translation Files",
        path: "/verification",
        // path: "/translation-upload",
        icon: <FaUpload />
      },
      {
        title: "Update Translation",
        path: "/verification",
        icon: <FaCheckCircle />
      },
      {
        title: "Split & Reorder",
        path: "/split-reorder",
        icon: <FaLayerGroup />
      },
      {
        title: "Deploy Translation",
        path: "/translationdataverification",
        icon: <FaRocket />
      }
    ]
  },
  {
  title: "Tracking Records",
  icon: <FaHistory />,
  children: [
    {
      title: "Tracking Records",
      path: "/trace",
      icon: <FaMapMarkerAlt />
    }
  ]
},

  {
    title: "Admin Panel",
    icon: <FaUserShield />,
    children: [
      {
        title: "Domain Page",
        path: "/domain",
        icon: <FaTools />
      }
    ]
  },
];